import { MINIPRO_LIST_URL, MINIPRO_CONF_URL } from '../conf';
import i18n from 'src/i18n';

function hasStation(type) {
  const sets = (window.QD_ADMIN_COMMON?.data?.set?.available) || [];
  for (const item of sets) {
    if (type === 'kf' && (item.type === 'cc' || item.type === 'fw')) {
      return true;
    }
    if (type === item.type) {
      return true;
    }
  }
  return false;
}

/* eslint-disable */
const getApplication = (ap) => {
  return 1 !== ap
    ? 2 !== ap
      // i18n-disable-next-line 字典 key，由消费方 i18n.t() 翻译
      ? '在线/电话'
      // i18n-disable-next-line 字典 key，由消费方 i18n.t() 翻译
      : '电话'
    // i18n-disable-next-line 字典 key，由消费方 i18n.t() 翻译
    : '在线';
};
/* eslint-enable */

export default {
  miniProListUrl: MINIPRO_LIST_URL,
  miniProConfUrl: MINIPRO_CONF_URL,

  miniProMaxCount: 20,

  getAuthCgi: '/mp/oauth/url',
  getAuthCallCgi: '/call/miniProgram/url',
  unbindCgi: '/mp/rest/wxInfo',
  unbindCallCgi: '/call/miniProgram/unbindQDMiniProgram',

  miniGridConf: {
    columnsOption: {
      accountName: {
        value: 'accountName',
        // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
        label: '微信小程序名称',
        width: 400,
        render(h, data) {
          return (
            <div class="mini-title">
              <img class="mini-avatar" src={data.row.faceUrl} />
              <div class="mini-info">
                <p class="mini-info-name">{data.row.accountName}</p>
                <p class="mini-info-application">{i18n.t('用于{type}客服', { type: i18n.t(getApplication(data.row.application)) })}</p>
              </div>
            </div>
          );
        },
      },
      wxAppId: {
        value: 'wxAppId',
        // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
        label: '小程序ID',
        width: 300,
        render(h, data) {
          return <div>{data.row.wxAppId}</div>;
        },
      },
      errorTips: {
        value: 'errorTips',
        label: '',
        width: 250,
        align: 'left',
        render(h, data) {
          return (
            <div style="color: var(--color-error-normal);">
              {data.row.errMsg && data.row.errMsg.title && (<div>{data.row.errMsg.title}</div>)}
              {data.row.errMsg && data.row.errMsg.tips && (<div>{data.row.errMsg.tips}</div>)}
            </div>
          );
        },
      },
      config: {
        value: 'config',
        label: '',
        width: 250,
        align: 'right',
        render(h, data) {
          const unbindPopconfirm = [
            {
              name: 'popmenu',
              value: 'unbind',
              modifiers: {
                click: true,
              },
            },
          ];
          const options = [
            {
              text: i18n.t('解绑在线客服'),
              row: data.row,
              application: 1,
            },
            {
              text: i18n.t('解绑电话客服'),
              row: data.row,
              application: 2,
            },
          ];
          if (2 - data.row.application > -1) {
            options.splice(2 - data.row.application, 1);
          }
          return (
            <div>
              <v-popmenu
                ref="unbind"
                placement="bottom-end"
                options={options}
                on-select={this.onUnbind}
              ></v-popmenu>
              {hasStation('kf') ? (
                <v-button type="link" kind="primary" class="mini-link" href={`${MINIPRO_CONF_URL}?id=${data.row.id}`}>
                  {i18n.t('配置接待')}
                </v-button>
              ) : (
                ''
              )}
              <v-button type="link" kind="primary" class="mini-link"
                {...{ directives: unbindPopconfirm }}
              >
                {i18n.t('解除绑定')}
              </v-button>
            </div>
          );
        },
      },
    },
  },
};
